<!--
  ~ Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->


<mat-card appearance="outlined" class="mat-card-container default-padding">
  <mat-card-title>Propulsion Segments
    <button mat-raised-button color="primary" id="suffix-create-button" class="create-button"
            (click)="openAddPopUp()">
      Create Suffix
    </button>
  </mat-card-title>
  <mat-divider></mat-divider>
  <mat-list id="suffix-list">
    <div *ngFor="let suffix of suffixes">
      <div class="suffix-item">
        <mat-list-item>{{ suffix.segmentSuffix }}</mat-list-item>
        <button mat-icon-button color="warn" (click)="deleteSuffix(suffix)">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
      <mat-divider></mat-divider>
    </div>

  </mat-list>
</mat-card>
